var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',[(_vm.dataLoaded)?_c('b-col',{attrs:{"lg":"12","sm":"12"}},[_c('v-chart',{staticClass:"chart",attrs:{"option":_vm.chartOptions}})],1):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }